import { render, staticRenderFns } from "./dataPower.vue?vue&type=template&id=947aa014&"
import script from "./dataPower.vue?vue&type=script&lang=ts&"
export * from "./dataPower.vue?vue&type=script&lang=ts&"
import style0 from "./dataPower.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports